var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-error\">\n<div class=\"pages-error-backgroundBand\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-error-content\">\n<h3>{{errorTitle}}</h3>\n<p>{{errorMessage}}</p>\n</div>\n</div>\n";
var id1="error.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/templates/error.html
// module id = 139
// module chunks = 0